<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'contestCountry',
      'codeState',
      'code',
      'content',
      'language',
      'contestType',
      'contestantEmail',
    ]),
    endpoint: function() {
      return (this.contestType === 'form') ? process.env.VUE_APP_API_URL + 'form/participate' : process.env.VUE_APP_API_URL + 'participate'
    }
  },
  data() {
    return {
      submitError: false,
      loading: false,
      success: false
    }
  },
  watch: {
    submitError: function(error) {
      if (error) {
        setTimeout(() => {
          this.submitError = false;
        }, 3000);
      }
    }
  },
  methods: {
    ...mapActions([
      'formSubmit',
      'resetAll'
    ]),
    submitForm: async function() {
      this.loading = true;
      let validations = [];

      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('register');

      for (let i = 0; i < this.$children.length; i++) {
        if (typeof this.$children[i].validate === 'function') {
          validations.push(this.$children[i].validate());
        }
      }

      Promise.all(validations).then(results => {
        let valid = true;
        results.forEach(result => {
          if (!result) {
            valid = false;
          }
        });

        if (valid) {
          let postData = {}
          postData['g-recaptcha-response'] = token

          for(let i = 0; i < this.$refs.form.elements.length; i++) {
            if(this.$refs.form.elements[i].name.length > 0) {
              if(this.$refs.form.elements[i].type === 'checkbox')  {
                postData[this.$refs.form.elements[i].name] = this.$refs.form.elements[i].checked
              } else  {
                postData[this.$refs.form.elements[i].name] = this.$refs.form.elements[i].value
              }
            }
          }
          postData.code = this.code;
          postData.language = this.language;
          postData.contestType = this.contestType

          axios.post(this.$refs.form.action, postData)
              .then(() => {
                this.formSubmit();
              })
              .catch(() => {
                this.submitError = true;
                this.loading = false;
              })
          //this.$refs.form.submit();
        } else {
          this.submitError = true;
          this.loading = false;
        }
      });
    }
  }
}
</script>